import React from 'react';
import PropTypes from 'prop-types';
import MomentOverview from '../base/MomentOverview/MomentOverview';

const ComplaintPositionEmailsTableRow = ({emailRow, isInternalApp}) => {
    return(
        <tr>
            <td>
                <MomentOverview moment={emailRow.sendingDate} />
            </td>
            <td>{emailRow.type}</td>
            <td>{emailRow.subject}</td>
            {isInternalApp===true && <td>{emailRow.recipient}</td>}
        </tr>
    );
};

ComplaintPositionEmailsTableRow.propTypes = {
    emailRow: PropTypes.object,
    isInternalApp: PropTypes.bool
};

export default ComplaintPositionEmailsTableRow;


// WEBPACK FOOTER //
// ./src/components/ComplaintPositionEmails/ComplaintPositionEmailsTableRow.js